const INTRO_SEEN_KEY = "gacha-instant-buyback-intro-seen"
const FIRST_PULL_CLOSED_KEY = "gacha-first-pull-result-closed"

function readFlag(key: string) {
  if (typeof window === "undefined") {
    return false
  }

  try {
    return window.localStorage.getItem(key) === "1"
  } catch {
    return false
  }
}

function writeFlag(key: string) {
  if (typeof window === "undefined") {
    return
  }

  try {
    window.localStorage.setItem(key, "1")
  } catch {
    // Private mode and quota errors should not block the purchase flow.
  }
}

export function hasClosedFirstPullResult() {
  return readFlag(FIRST_PULL_CLOSED_KEY)
}

export function markFirstPullResultClosed() {
  writeFlag(FIRST_PULL_CLOSED_KEY)
}

export function hasSeenInstantBuybackIntro() {
  return readFlag(INTRO_SEEN_KEY)
}

export function markInstantBuybackIntroSeen() {
  writeFlag(INTRO_SEEN_KEY)
}

export function shouldShowInstantBuybackIntro() {
  if (hasSeenInstantBuybackIntro()) {
    return false
  }

  return !hasClosedFirstPullResult()
}

export function shouldShowInstantBuybackIntroAfterBuybackAccepted() {
  return !hasSeenInstantBuybackIntro()
}
